<template>
    <vue-tel-input v-model="phone" name="phone" id="phone"></vue-tel-input>
</template>

<script>
    import VueTelInput from 'vue-tel-input';

    export default {
        components: {
            VueTelInput,
        },
        props: {
            prev_phone: null,
        },
    data() {
        return  {
            phone: null,
        }
    },
    mounted:function(){
            this.phone = this.prev_phone;
        },
    http: {
        root: '/root',
        headers: {
            'X-CSRF-Token': Laravel.csrfToken
        }
    }
    
};
</script>
